// extracted by mini-css-extract-plugin
export default {"backdrop":"AlertModal_backdrop__pCUiC","modal":"AlertModal_modal__MjaSG","fadeIn":"AlertModal_fadeIn__4IiO2"};